<mat-card appearance="outlined" [style]="{ width: 'auto' }">
  <mat-card-title class="tw-flex tw-justify-between">
    <span>{{ 'administration.user.item.userRoles.title' | translate }}</span>

    <span class="link" (click)="manageRoles()">{{ 'administration.user.item.userRoles.manageRoles' | translate }}</span>
  </mat-card-title>

  <div
    *ngIf="rolesSelectionService.rolesModelToRoleList(rolesControl.value).length; else noRolesTemplate"
    class="checkbox-group"
  >
    <mat-chip-listbox class="mat-chip-list-stacked">
      <ng-container *ngFor="let group of rolesControl.value | keyvalue">
        <div class="group">
          <div *ngIf="group.value?.length" class="group__title">
            {{ group.key | startCase | titlecase }}
          </div>

          <div *ngFor="let role of group.value | sortBy : 'asc'" class="group__role tw-gap-x-5 tw-flex">
            <mat-chip-option [selectable]="false" [removable]="isDataEditable" (removed)="removeRole(group.key, role)">
              {{ 'administration.user.item.userRoles.roles.' + role | translate }}
              <ui-svg-icon [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
            </mat-chip-option>
          </div>
        </div>
      </ng-container>
    </mat-chip-listbox>
  </div>
</mat-card>

<ng-template #noRolesTemplate>
  {{ 'common.field.please' | translate }}
  <span class="link" (click)="manageRoles()">{{ 'administration.user.item.userRoles.addRoles' | translate }}</span>
</ng-template>
